import { ParticipateCompetitions } from "@brg/api";
import { Colors, FInter, FlexBox, useBreakpoint, useIsMobile } from "@brg/ui";
import { STATUSES } from "_competition/const";
import { CompetitionView } from "_competition/pages/AllCompetitionsPage/CompetitionView";
import { getCompetitionTitle } from "_competition/pages/AllCompetitionsPage/helpers/competitionUtils";
import { CompetitionContainer } from "_competition/pages/AllCompetitionsPage/styled";
import { LayoutConst } from "core";
import { FC, useCallback } from "react";
import { ProjectsGridNew } from "shared/components/grids";
import { computeProjectMapTile } from "shared/helpers/types/computed/ComputedProject";
import styled, { useTheme } from "styled-components";

const CompetitionTitle = styled(FInter.SectionTitleSubtitleBoldDiv)`
  color: ${Colors.galBlack100};
  font-style: normal;
  font-weight: 700;
  font-size: 30px;
  line-height: 40px;
  letter-spacing: -0.02em;

  a {
    color: ${({ theme }) => theme.app.text} !important;
  }

/*
  @media (max-width: ${LayoutConst.screen.m}px) {
    font-weight: 700;
    font-size: 30px;
    line-height: 40px;
  }
*/

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-weight: 500;
    font-size: 22px;
    line-height: 28px;
  }
`

const ProfileCompetitionContainer = styled(CompetitionContainer)`
  margin-top: 0!important;
`

export interface DesignerCompetitionsTabProps {
  competitions: ParticipateCompetitions;
  onNotParticipateCompetition?: (projectId: string, competitionId: string) => void;
}

export const DesignerCompetitionsTab: FC<DesignerCompetitionsTabProps> = ({
  competitions,
  onNotParticipateCompetition,
}) => {
  const isMobile = useIsMobile();
  const theme = useTheme();
  const is744BP = useBreakpoint(LayoutConst.screen.s)

  const onNotParticipateHandler = useCallback((projectId: string, competitionId: string) => {
    const confirmation = window.confirm('Вы действительно не хотите участвовать в конкурсе?');
    if (confirmation) {
      onNotParticipateCompetition?.(projectId, competitionId);
    }
  }, [onNotParticipateCompetition])

  if (competitions.totalProjectsCount === 0) {
      return null;
  }

  return (
    <FlexBox
      direction={"column"}
      directionMobile={"column"}
      width={"100%"}
      gy={isMobile ? 19.6 : 48}
    >
      {competitions?.competitionInfos?.map(x => {
        const projectsCount = x.projects.length;
        const firstRowProjects = is744BP ? [] : x.projects.slice(0, Math.min(2, projectsCount));
        const secondRowProjects = is744BP ? x.projects : (projectsCount > 2 ? x.projects.slice(2, projectsCount) : []);
        const isCanNotParticipateCompetition = x.competition.status !== STATUSES.Completed;
        const competitionId = x.competition.competitionId;

        return (
          <FlexBox>
            <FlexBox direction={'column'} directionMobile={'column'} flex={'1'}>
              <FlexBox align={'flex-end'} flex={'1'} offsetBottom={24}>
                <FlexBox justify={'space-between'} flex={'1'}>
                  <CompetitionTitle color={theme.designerPage.textColor}>
                    <a href={`${process.env.REACT_APP_URL_HSEDESIGN_RU}/competition/${x.competition.competitionId}`} target={'_BLANK'} rel="noreferrer">
                      {getCompetitionTitle(x.competition)}
                    </a>
                  </CompetitionTitle>
                </FlexBox>
              </FlexBox>
              <ProfileCompetitionContainer>
                <FlexBox>
                  <CompetitionView competition={x.competition} needLink={true} isProfile />
                </FlexBox>
                {firstRowProjects.length > 0 && (
                  <FlexBox>
                    <ProjectsGridNew
                      columns={2}
                      isHeadCommentsVisibleLocal={true}
                      isMobileMoreVisible={isMobile}
                      isCanNotParticipate={isCanNotParticipateCompetition}
                      currentCompetitionId={competitionId}
                      onNotParticipate={(projectId: string) => onNotParticipateHandler(projectId, x.competition.competitionId)}
                      // @ts-ignore
                      projects={firstRowProjects.map(computeProjectMapTile)}
                    />
                  </FlexBox>
                )}
              </ProfileCompetitionContainer>
              {secondRowProjects.length > 0 && (
                <FlexBox>
                  <ProjectsGridNew
                    isHeadCommentsVisibleLocal={true}
                    currentCompetitionId={competitionId}
                    isCanNotParticipate={isCanNotParticipateCompetition}
                    isMobileMoreVisible={isMobile}
                    onNotParticipate={(projectId: string) => onNotParticipateHandler(projectId, x.competition.competitionId)}
                    // @ts-ignore
                    projects={secondRowProjects.map(computeProjectMapTile)}
                  />
                </FlexBox>
              )}
            </FlexBox>
          </FlexBox>
        );
      })}
    </FlexBox>
  );
};
import { ParticipateCompetitions } from "@brg/api";
import { Colors, FInter, FlexBox, useBreakpoint, useIsMobile } from "@brg/ui";
import { STATUSES } from "_competition/const";
import { CompetitionView } from "_competition/pages/AllCompetitionsPage/CompetitionView";
import { getCompetitionTitle } from "_competition/pages/AllCompetitionsPage/helpers/competitionUtils";
import { CompetitionContainer } from "_competition/pages/AllCompetitionsPage/styled";
import { LayoutConst } from "core";
import { FC, useCallback } from "react";
import { ProjectsGridNew } from "shared/components/grids";
import { computeProjectMapTile } from "shared/helpers/types/computed/ComputedProject";
import styled, { useTheme } from "styled-components";

const CompetitionTitle = styled(FInter.SectionTitleSubtitleBoldDiv)`
  color: ${Colors.galBlack100};
  font-style: normal;
  font-weight: 700;
  font-size: 30px;
  line-height: 40px;
  letter-spacing: -0.02em;

  a {
    color: ${({ theme }) => theme.app.text} !important;
  }

/*
  @media (max-width: ${LayoutConst.screen.m}px) {
    font-weight: 700;
    font-size: 30px;
    line-height: 40px;
  }
*/

  @media (max-width: ${LayoutConst.screen.m}px) {
    font-weight: 500;
    font-size: 22px;
    line-height: 28px;
  }
`

const ProfileCompetitionContainer = styled(CompetitionContainer)`
  margin-top: 0!important;
`

export interface DesignerCompetitionsTabProps {
  competitions: ParticipateCompetitions;
  onNotParticipateCompetition?: (projectId: string, competitionId: string) => void;
}

export const DesignerCompetitionsTab: FC<DesignerCompetitionsTabProps> = ({
  competitions,
  onNotParticipateCompetition,
}) => {
  const isMobile = useIsMobile();
  const theme = useTheme();
  const is744BP = useBreakpoint(LayoutConst.screen.s)

  const onNotParticipateHandler = useCallback((projectId: string, competitionId: string) => {
    const confirmation = window.confirm('Вы действительно не хотите участвовать в конкурсе?');
    if (confirmation) {
      onNotParticipateCompetition?.(projectId, competitionId);
    }
  }, [onNotParticipateCompetition])

  if (competitions.totalProjectsCount === 0) {
      return null;
  }

  return (
    <FlexBox
      direction={"column"}
      directionMobile={"column"}
      width={"100%"}
      gy={isMobile ? 19.6 : 48}
    >
      {competitions?.competitionInfos?.map(x => {
        const projectsCount = x.projects.length;
        const firstRowProjects = is744BP ? [] : x.projects.slice(0, Math.min(2, projectsCount));
        const secondRowProjects = is744BP ? x.projects : (projectsCount > 2 ? x.projects.slice(2, projectsCount) : []);
        const isCanNotParticipateCompetition = x.competition.status !== STATUSES.Completed;
        const competitionId = x.competition.competitionId;

        return (
          <FlexBox>
            <FlexBox direction={'column'} directionMobile={'column'} flex={'1'}>
              <FlexBox align={'flex-end'} flex={'1'} offsetBottom={24}>
                <FlexBox justify={'space-between'} flex={'1'}>
                  <CompetitionTitle color={theme.designerPage.textColor}>
                    <a href={`${process.env.REACT_APP_URL_HSEDESIGN_RU}/competition/${x.competition.competitionId}`} target={'_BLANK'} rel="noreferrer">
                      {getCompetitionTitle(x.competition)}
                    </a>
                  </CompetitionTitle>
                </FlexBox>
              </FlexBox>
              <ProfileCompetitionContainer>
                <FlexBox>
                  <CompetitionView competition={x.competition} needLink={true} isProfile />
                </FlexBox>
                {firstRowProjects.length > 0 && (
                  <FlexBox>
                    <ProjectsGridNew
                      columns={2}
                      isHeadCommentsVisibleLocal={true}
                      isMobileMoreVisible={isMobile}
                      isCanNotParticipate={isCanNotParticipateCompetition}
                      currentCompetitionId={competitionId}
                      onNotParticipate={(projectId: string) => onNotParticipateHandler(projectId, x.competition.competitionId)}
                      // @ts-ignore
                      projects={firstRowProjects.map(computeProjectMapTile)}
                    />
                  </FlexBox>
                )}
              </ProfileCompetitionContainer>
              {secondRowProjects.length > 0 && (
                <FlexBox>
                  <ProjectsGridNew
                    isHeadCommentsVisibleLocal={true}
                    currentCompetitionId={competitionId}
                    isCanNotParticipate={isCanNotParticipateCompetition}
                    isMobileMoreVisible={isMobile}
                    onNotParticipate={(projectId: string) => onNotParticipateHandler(projectId, x.competition.competitionId)}
                    // @ts-ignore
                    projects={secondRowProjects.map(computeProjectMapTile)}
                  />
                </FlexBox>
              )}
            </FlexBox>
          </FlexBox>
        );
      })}
    </FlexBox>
  );
};
